import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { DamageC2Code } from "../../../services/damage/DamageC2Code";
import FormField from "../../../components/form-field/FormField";
import { RequiredOptionValidatorModel } from "../../../services/form/validators/required/RequiredOptionValidator";
import { Dropdown } from "../../../components/dropdown/Dropdown";

interface EditC2CodeProps {
  labelKey: string;
  value?: DamageC2Code;
  c2Codes: DamageC2Code[];
  onChange: (c2Code: DamageC2Code) => void;
  disabled: boolean;
  setFieldValue: Function;
}

export default observer(function EditC2Code(props: EditC2CodeProps) {
  const { labelKey, value, onChange, c2Codes, disabled, setFieldValue } = props;
  const [requiredOptionValidator] = useState(() =>
    RequiredOptionValidatorModel.create({ option: value })
  );

  useEffect(() => {
    requiredOptionValidator.set(value);
  }, [requiredOptionValidator, value]);

  return (
    <FormField
      id="c2-code"
      labelKey={labelKey || "general.damage.characterization2"}
      fieldName="c2Code"
      fieldValue={value}
      validator={requiredOptionValidator}
      required
      disabled={disabled}
      children={() => (
        <div className="form-element-container">
          <Dropdown
            selectedOption={
              value && value.code ? { ...value, id: value.code, name: value.label } : null
            }
            options={c2Codes.map((x: DamageC2Code) => ({ ...x, id: x.code, name: x.label }))}
            onChange={onChange}
            fieldName="c2code"
            setFieldValue={setFieldValue}
            disabled={disabled}
            placeholderKey="EditDamage.c2Code.selection"
          />
        </div>
      )}
      errorName="c2Code"
    />
  );
});
